<template>
  <div>

    <v-card flat class="ma-md-8 mt-md-2 rounded-lg pa-4">

      <v-skeleton-loader type="list-item@8" v-if="loading"></v-skeleton-loader>

      <v-treeview
          v-model="tree"
          :open="initiallyOpen"
          :items="items"
          item-key="folder_id"
          item-text="folder_name"
          open-on-click
          dense
          v-if="items && !loading"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="!item.file">
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>
          <v-icon v-else>
            {{ files[item.file] }}
          </v-icon>
        </template>
        <template v-slot:label="{item}">

          <template v-if="item.folder_id === editedIndex">
            <v-text-field v-model="editedItem.folder_name" :hide-details="true" dense single-line :autofocus="true" @blur="saveItem"></v-text-field>
          </template>
          <template v-else>
            {{ item.folder_name }}
            <v-icon
                depressed
                role="button"
                @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </template>

          <template>
            <v-icon
                depressed
                :color="(item.folder_hidden) ? 'error' : ''"
                role="button"
                @click="hideFolder(item)"
            >
              <template v-if="item.folder_hidden">
                mdi-eye-off
              </template>
              <template v-else>
                mdi-eye
              </template>
            </v-icon>
          </template>

          <v-icon
              depressed
              color="error"
              role="button"
              @click="deleteFolderConfirm(item)"
          >
            <template>
              mdi-delete
            </template>

          </v-icon>

        </template>
      </v-treeview>
    </v-card>

  </div>
</template>

<script>
import {mapActions} from "vuex";
import axios from "axios";
import userHelpers from "@/mixins/userHelpers";
import {cloneDeep} from "lodash";

export default {
  mixins: [
      userHelpers
  ],
  data () {
    return {
      loading: true,
      tree: [],
      initiallyOpen: ['public'],
      items: [],
      editedItem: {},
      editedIndex: -1,
    }
  },
  mounted () {
    this.getDataFromApi()
  },
  computed: {
    headers() {
      let headers = [
        {
          text: 'Map naam',
          align: 'start',
          sortable: true,
          value: 'folder_name',
        },
      ];

      if (this.userHasRole('admin') || this.userHasRole('client_manager')) {
        // Add change visibility button
        headers.push({ value: "folder_hidden", sortable: false, align: 'end' })
      }

      // Add actions
      headers.push({ value: "actions", sortable: false, align: 'end' })

      return headers
    }
  },
  methods: {
    ...mapActions(["getFolders"]),
    async getDataFromApi() {
      this.loading = true;

      try {
        await this.getFolders();
        // Copy to 'items' because we don't want to (inline) edit the rows from the store.
        this.items = cloneDeep(this.$store.state.folders)
      } catch (error) {
        console.log(error);
      }
      finally {
        this.loading = false;
      }
    },
    async deleteFolderConfirm(folder) {
      // if (folder.folder_is_empty) {
        if (
            confirm('Weet je zeker dat je de map "'+folder.folder_name+'" wilt verwijderen?')
        ) {
          await this.deleteFolder(folder);
        }
      // }
      // else {
      //   alert('De map "'+folder.folder_name+'" kan niet worden verwijderd omdat deze nog formulieren en/of mappen bevat.');
      // }
    },
    async deleteFolder(folder) {
      // Get the client id from the store
      let client_id = this.$store.getters.CurrentClient;

      this.loading = true
      // Fetch results form the API
      try {
        let response = await axios.delete('api/client/'+client_id+'/folder/'+folder.folder_id);
        
        if (!response.data && (!response.status || response.status >= 300)) {
          throw new Error(response.toString());
        }

        this.$toast.success('Map "'+folder.folder_name+'" is verwijderd.');

        await this.getDataFromApi();
      } catch (error) {
        // Get the error message from the response
        let error_message = "Map kon niet worden verwijderd.";
        if (error.response && error.response.data && error.response.data.error) {
          error_message = error.response.data.error;
        }
        this.$toast.error(error_message);

      } finally {
        this.loading = false
      }
    },
    async hideFolder(folder) {
      this.loading = true
      // Fetch results form the API
      try {
        // Change hidden flag
        let newHiddenValue = true
        if (folder.folder_hidden) {
          newHiddenValue = false
        }
        // Update folder, change the hidden value
        let response = await axios.patch('api/folder/'+folder.folder_id+'/set-hidden', {hidden: newHiddenValue});

        if (!response.data && (!response.status || response.status >= 300)) {
          throw new Error(response.toString());
        }

        if (newHiddenValue) {
          this.$toast.success('Map "'+folder.folder_name+'" is verborgen.');
        }
        else {
          this.$toast.success('Map "'+folder.folder_name+'" is zichtbaar.');
        }

        await this.getDataFromApi();
      } catch (error) {
        console.log(error);
        this.$toast.error("Map kon niet worden verborgen.");

      } finally {
        this.loading = false
      }
    },
    editItem(item) {
      this.editedIndex = item.folder_id
      this.editedItem = Object.assign({}, item);
    },
    stopEditItem() {
      this.editedIndex = -1
      this.editedItem = {}
    },
    async saveItem() {
      // Get the edited item
      let folder = this.editedItem
      try {
        await this.renameFolder(folder)
        // Find index in items
        let index = this.items.findIndex(e=> e.folder_id === folder.folder_id);
        // Apply the edit to the current row item
        this.$set(this.items, index, folder);
        // Stop editing
        this.stopEditItem()
      } catch(error) {
        console.log(error);
      }
    },
    async renameFolder(folder) {
      try {
        // Update folder
        let response = await axios.patch('api/folder/'+folder.folder_id+'/rename', {folder_name: folder.folder_name});

        if (!response.data && (!response.status || response.status >= 300)) {
          throw new Error(response.toString());
        }

      } catch (error) {
        console.log(error);
        this.$toast.error("Map kon niet worden aangepast.");
      }
    }
  },
}
</script>

<style scoped>

</style>